<button 
  class="btn-primary payment-btn" 
  (click)="onClickEvent()"
  [disabled]="disable"
  [ngbTooltip]="tooltip"
>
  <div class="fix-content">
    <ng-container *ngIf="!disable; else svg">
      <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.25 2H11.5V0.5H10V2H4V0.5H2.5V2H1.75C0.9175 2 0.2575 2.675 0.2575 3.5L0.25 14C0.25 14.825 0.9175 15.5 1.75 15.5H12.25C13.075 15.5 13.75 14.825 13.75 14V3.5C13.75 2.675 13.075 2 12.25 2ZM12.25 14H1.75V6.5H12.25V14ZM4.75 9.5H3.25V8H4.75V9.5ZM7.75 9.5H6.25V8H7.75V9.5ZM10.75 9.5H9.25V8H10.75V9.5ZM4.75 12.5H3.25V11H4.75V12.5ZM7.75 12.5H6.25V11H7.75V12.5ZM10.75 12.5H9.25V11H10.75V12.5Z" 
          fill="#002E9D"/>
      </svg> 
    </ng-container> 
    <ng-template #svg>
      <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.25 2H11.5V0.5H10V2H4V0.5H2.5V2H1.75C0.9175 2 0.2575 2.675 0.2575 3.5L0.25 14C0.25 14.825 0.9175 15.5 1.75 15.5H12.25C13.075 15.5 13.75 14.825 13.75 14V3.5C13.75 2.675 13.075 2 12.25 2ZM12.25 14H1.75V6.5H12.25V14ZM4.75 9.5H3.25V8H4.75V9.5ZM7.75 9.5H6.25V8H7.75V9.5ZM10.75 9.5H9.25V8H10.75V9.5ZM4.75 12.5H3.25V11H4.75V12.5ZM7.75 12.5H6.25V11H7.75V12.5ZM10.75 12.5H9.25V11H10.75V12.5Z" 
          fill="#7A91C8"/>
      </svg> 
    </ng-template>
    <span>{{'Programar pago'|translate}}</span>
  </div>
</button>